export function generateRandomString(length: number = 8): string {
  if (length < 8) {
    throw new Error("Password length must be at least 8 characters.");
  }

  const charset = {
    upperCase: "ABCDEFGHIJKLMNOPQRSTUVWXYZ",
    lowerCase: "abcdefghijklmnopqrstuvwxyz",
    numbers: "0123456789",
    specialCharacters: "!@#$%^&*()_+[]{}|;:,.<>?",
  };

  const getRandomChar = (chars: string) =>
    chars[Math.floor(Math.random() * chars.length)];

  // Ensure the result has at least one of each required character type
  const result = [
    getRandomChar(charset.upperCase),
    getRandomChar(charset.lowerCase),
    getRandomChar(charset.numbers),
    getRandomChar(charset.specialCharacters),
  ];

  const combinedCharset =
    charset.upperCase +
    charset.lowerCase +
    charset.numbers +
    charset.specialCharacters;

  // Fill the remaining length with random characters from the combined charset
  while (result.length < length) {
    result.push(getRandomChar(combinedCharset));
  }

  const password = result.sort(() => Math.random() - 0.5).join("");

  return escapeHTML(password);
}

function escapeHTML(input: string): string {
  return input
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
